import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function DateInput(props) {
  const { label, date, setDate } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={date}
        onChange={(newValue) => setDate(newValue)}
        slotProps={{
          textField: {
            sx: {
              flexGrow: "1",
              maxWidth: "250px",
              backgroundColor: "white",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
